export default "__VITE_ASSET__C2c3akZ2__"